/**
 * The LayerHost is a div which is created in place
 * where you want to "house" a portaled content
 */
import { forwardRef } from 'preact/compat';

const LayerHost = forwardRef<HTMLDivElement>((_props, ref) => {
  return <div id="__oj_layerhost_container" ref={ref} />;
});

LayerHost.displayName = 'Forwarded<LayerHost>';

export default LayerHost;
